<template>
  <!---->
  <div>
    <el-tag
      class="tag-class"
      v-for="tag in dynamicTags"
      :key="tag.name"
      closable
      :disable-transitions="false"
      @click.native="onClick(tag)"
      :type="tag.type"
      @close="handleClose(tag)">
      {{tag.name}}
    </el-tag>
  </div>
</template>

<script>
export default {
  name: "HeaderTag"
  ,
  components: {},
  data() {
    return {
      dynamicTags: [],
    }
  },
  methods: {
    handleClose(tag) {
      tag.type = "";
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
      let tagList = this.dynamicTags;
      if(tagList.length>0){
        this.dynamicTags[this.dynamicTags.length-1].type="";
        let lastTag = this.dynamicTags[this.dynamicTags.length-1];
        sessionStorage.setItem("TAG",JSON.stringify(tagList));
        this.onClick(lastTag);
      }else{
        this.$router.push("/members");
      }
    },
    onClick(tag){
      // console.log(tag);
      this.$router.push(tag.url);
    },
    tagInit(){
      let tag = [];
      if(sessionStorage.getItem("TAG") ==null || sessionStorage.getItem("TAG")==""){

      }else{
        tag=JSON.parse(sessionStorage.getItem("TAG"));
      }
      if(tag.length>0){
        this.dynamicTags = tag;
        for(let j=0;j<this.dynamicTags.length;j++) {
          if (this.dynamicTags[j].url == this.$route.path) {
            this.dynamicTags[j].type = '';
          } else {
            this.dynamicTags[j].type = "info";
          }
        }
      }
    }
  },
  mounted() {
    let that = this;
    setTimeout(function () {
      that.tagInit();
    },500);
  }
}
</script>

<style scoped>
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.tag-class{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/component/HeaderTag.vue